import { makeStyles, Typography } from '@material-ui/core'
import { FC } from 'react'
import useTranslate from '../../../../i18n/useTranslate'
import { ResponseDataApproveStatus } from '../../../../services/um/useDashboard'
import Item from './Item'

const Consideration: FC<{ data: ResponseDataApproveStatus[] }> = ({ data }) => {
    const translate = useTranslate()
    const classes = useStyles()
    return (
        <>
            <Typography variant="h5" className={classes.header}>
                {translate.get('UM.DASHBOARD.CONSIDERATION')}
            </Typography>

            <div className={classes.container}>
                {data.map((item) => (
                    <div className={classes.content} key={item.id}>
                        <Item
                            title={translate.languageStore.currentLanguage === 'th' ? item.label.th : item.label.en}
                            number={item.number}
                            isAll={true}
                        />
                    </div>
                ))}
            </div>
        </>
    )
}
const useStyles = makeStyles((theme) => ({
    header: {
        margin: '16px 0px',
        fontWeight: 'bolder',
    },
    container: {
        width: '100%',
        display: 'flex',
        flexWrap: 'nowrap',
    },
    content: {
        width: '16.66%',
        flexGrow: 1,

        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            width: '25%',
            minWidth: '220px',
            maxWidth: '236px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '33.33%',
            minWidth: '200px',
            maxWidth: '260px',
        },

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            maxWidth: '400px',
        },
    },
}))

export default Consideration
